/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cancel': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M3 3l26 26M3 3l26 26M3 29L29 3M3 29L29 3" _stroke="#8F3F3F" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/cancel.js